import { FC } from 'react';
import { Box } from '@mui/material';
import { createUseStyles } from 'react-jss';
import Icon from '../icon';

type McpServerIconSize = 'small' | 'medium';

interface Props {
  icon?: string;
  serverName?: string;
  size?: McpServerIconSize;
}

const SizeMap: Record<McpServerIconSize, number> = {
  small: 20,
  medium: 24,
};

const useStyles = createUseStyles<string, { size: McpServerIconSize }>({
  serverIcon: ({ size }) => ({
    display: 'flex',
    flexShrink: 0,
    '& img': {
      height: SizeMap[size],
      width: SizeMap[size],
    },
  }),
});

const McpServerIcon: FC<Props> = ({ icon = '', serverName = '', size = 'medium' }) => {
  const styles = useStyles({ size });
  const hasIcon = !!icon;

  return (
    <Box className={styles.serverIcon}>
      {hasIcon && <img src={icon} alt={serverName} />}
      {!hasIcon && <Icon name="mcp-server" color="grey" size={size} />}
    </Box>
  );
};

export default McpServerIcon;
